import React, { useEffect, useState } from 'react';
import api from '../services/api';
import { Plus, Building2 } from 'lucide-react';
import toast from 'react-hot-toast';

export default function Companies() {
  const [companies, setCompanies] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showNew, setShowNew] = useState(false);
  const [form, setForm] = useState({ name:'', taxId:'', email:'', phone:'', city:'' });

  useEffect(() => {
    api.get('/companies').then(r => setCompanies(r.data)).catch(() => toast.error('Error')).finally(() => setLoading(false));
  }, []);

  const handleCreate = async (e) => {
    e.preventDefault();
    try {
      const { data } = await api.post('/companies', form);
      setCompanies(prev => [...prev, data]);
      toast.success('Empresa creada');
      setShowNew(false);
      setForm({ name:'', taxId:'', email:'', phone:'', city:'' });
    } catch (err) { toast.error(err.response?.data?.error || 'Error'); }
  };

  return (
    <div className="page-companies">
      <div className="page-header">
        <div><h1>Empresas</h1><p className="subtitle">Empresas instaladoras</p></div>
        <button className="btn btn-primary" onClick={() => setShowNew(true)}><Plus size={18} /> Nueva empresa</button>
      </div>
      {loading ? <div className="loading-screen"><div className="spinner" /></div> : (
        <div className="project-grid">
          {companies.map(c => (
            <div key={c.id} className="project-card">
              <div className="project-card-header"><Building2 size={20} /><span className={`status-badge ${c.is_active ? 'green' : 'gray'}`}>{c.is_active ? 'Activa' : 'Inactiva'}</span></div>
              <h3 className="project-name">{c.name}</h3>
              <div className="project-meta">
                {c.country_name && <span>{c.country_name}</span>}
                {c.city && <span>{c.city}</span>}
                <span>{c.user_count} usuarios</span>
                <span>{c.project_count} proyectos</span>
              </div>
            </div>
          ))}
        </div>
      )}
      {showNew && (
        <div className="modal-overlay" onClick={() => setShowNew(false)}>
          <div className="modal" onClick={e => e.stopPropagation()}>
            <h2>Nueva Empresa</h2>
            <form onSubmit={handleCreate}>
              <div className="form-group"><label>Nombre *</label><input required value={form.name} onChange={e => setForm({...form, name: e.target.value})} /></div>
              <div className="form-row">
                <div className="form-group"><label>CIF/NIF</label><input value={form.taxId} onChange={e => setForm({...form, taxId: e.target.value})} /></div>
                <div className="form-group"><label>Ciudad</label><input value={form.city} onChange={e => setForm({...form, city: e.target.value})} /></div>
              </div>
              <div className="form-row">
                <div className="form-group"><label>Email</label><input type="email" value={form.email} onChange={e => setForm({...form, email: e.target.value})} /></div>
                <div className="form-group"><label>Teléfono</label><input value={form.phone} onChange={e => setForm({...form, phone: e.target.value})} /></div>
              </div>
              <div className="form-actions">
                <button type="button" className="btn btn-secondary" onClick={() => setShowNew(false)}>Cancelar</button>
                <button type="submit" className="btn btn-primary">Crear</button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}
